export function getAnimation(
  property = 'all',
  timingFunction = 'ease',
  duration = 300
) {
  return `${property} ${duration}ms ${timingFunction}`;
}
